export default __webpack_public_path__ + "static/media/icon_bandStyle_Hammered.76b4c35d.png";